import PropTypes from "prop-types"
import { Component } from "react"
import classNames from "classnames"
import "./style.scss"

const OPTION = PropTypes.shape({
  value: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
})

class Item extends Component {
  onClick = () => {
    const { option: { value }, onSelect } = this.props
    onSelect(value)
  }

  render() {
    const { selectedValue, option: { display, value } } = this.props

    const selected = selectedValue === value
    return <li className={classNames({ selected })} onClick={this.onClick}>{display}</li>
  }
}

Item.propTypes = {
  option: OPTION.isRequired,
  selectedValue: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
}

function InlineSelector({ options, selectedValue, onSelect }) {
  const props = { selectedValue, onSelect }
  return <ol className="components_inline-selector">
    {options.map(option => <Item key={option.value} {...props} option={option} />)}
  </ol>
}

InlineSelector.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(OPTION).isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default InlineSelector
